/**
 * FEATURE STRIP CANON — reserved plot for every hit panel (#1–#N).
 *
 * Contract: `./riskCardLayoutCanon.js`.
 * Always render inside RiskHitPanelLayout's `feature` slot (never outside).
 * Fixed chrome + body height — content cannot change the outer size.
 * Put timeline / signal / forecast widgets here only.
 */
export const RISK_HIT_FEATURE = Object.freeze({
  root: 'box-border h-[9.25rem] shrink-0 overflow-hidden rounded-xl border border-slate-200 bg-slate-50 px-3 py-1.5 dark:border-slate-800 dark:bg-slate-900/40',
  title: 'mb-1 truncate text-xs font-medium leading-4 text-slate-600 dark:text-slate-300',
  /** Fixed plot area (timeline / signal / forecast). */
  body: 'relative h-[6.5rem] min-h-[6.5rem] max-h-[6.5rem] overflow-hidden',
});

/**
 * @param {object} props
 * @param {import('react').ReactNode} [props.title]
 * @param {import('react').ReactNode} [props.children]
 */
export default function RiskHitFeatureBlock({ title = '\u00a0', children = null }) {
  return (
    <div className={RISK_HIT_FEATURE.root} data-risk-feature-block="canon">
      <p className={RISK_HIT_FEATURE.title}>{title || '\u00a0'}</p>
      <div className={RISK_HIT_FEATURE.body}>{children}</div>
    </div>
  );
}
